import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import map from 'lodash/map';

import { getFilteredParameterValuesNotEmpty } from 'store/dataset';

import DotsPlot from 'components/DotsPlot';


class DotPlotContainer extends React.PureComponent {

  get dotPlotData () {
    return map(this.props.filteredDataset, (value, index) => ({ value, id: index }));
  }

  render () {
    return (
      <DotsPlot
        dots={this.dotPlotData}
        yAxisLabel="Number of observations"
        xAxisLabel={this.props.parameter}
      />
    );
  }
}

DotPlotContainer.propTypes = {
  parameter: PropTypes.string.isRequired,
  filteredDataset: PropTypes.array.isRequired
};

const mapStateToProps = (state, props) => ({
  filteredDataset: getFilteredParameterValuesNotEmpty(state, props.parameter)
}
);
export default connect(mapStateToProps)(DotPlotContainer);
